import React from "react";
import AlertContext from './AlertContext';
/**
 * The react hook for creating alerts and confirm alerts
 *
 * @example
 *
 * ```
 *  alerts.show("Item updated")
 * ```
 *
 *
 * @example
 * ```
 *  alerts.show({title: "Info", content: "Item updated", cancelButtonTitle: "Ok" })
 * ```
 *
 *
 * @example
 * ```
 * Auto close an alert (disabled by default)
 *
 * alerts.show({content: 'Item updated', autoClose: true, closeAfter: 2000})
 * ```
 *
 *
 *
 * @example
 * ```
 *  wait until alert is closed
 *
 *  await alerts.show("Item updated")
 *  ... execute the rest
 * ```
 *
 *
 * @example
 * ```
 *  let hasConfirmed = await alerts.confirm("Are you sure?")
 *
 *  if(hasConfimed) {
 *      ... execute the rest
 *  }
 *
 * ```
 *
 *
 * @example
 * ```
 *  alerts.confirm("Are you sure?")
 * .then(hasConfirmed => {
 *      if(hasConfirmed) {
 *          ... execute the rest
 *      }
 * })
 * ```
 *
 * @export
 */
const useAlert = () => {
    const context = React.useContext(AlertContext);
    return {
        show: context.show,
        confirm: context.confirm,
        form: context.form,
        info: context.info,
        success: context.success,
        warning: context.warning,
        error: context.error
    };
};
export default useAlert;
